import "./api-error.scss";

window.app.directive("apiError", [
  function() {
    return {
      restrict: "E",
      scope: {
        error: "<error",
        view: "@view"
      },
      template: require("./api-error.html")
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/api-error/api-error.js